import { usePathname } from 'next/navigation';

const usePathContains = () => {
  const pathname = usePathname();

  const checkPathHas = (key: string) => {
    return pathname?.includes(key);
  };

  const checkPathExactHas = (key: string) => {
    if (!pathname) return false;
    const segments = pathname?.split('/')?.filter(Boolean);
    return segments?.includes(key);
  };

  return {
    checkPathHas,
    checkPathExactHas
  };
};

export default usePathContains;
